/* esm.sh - @radix-ui/react-menubar@1.1.16 */
export * from "/*@radix-ui/react-menubar@1.1.16/esnext/react-menubar.mjs";
